module.exports = __webpack_public_path__ + "static/233-ca5c30461d188c451ec9ef83b22a698b.svg";